"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M2.71 13.286A15.983 15.983 0 0 1 29.879 7.3l3.268-3.445a.5.5 0 0 1 .853.352V16H22.788a.5.5 0 0 1-.354-.854l4.613-4.863a11.887 11.887 0 0 0-20.393 4.128.488.488 0 0 1-.594.334l-2.993-.816a.518.518 0 0 1-.357-.643zM13.222 20a.5.5 0 0 1 .354.854l-4.617 4.862a11.88 11.88 0 0 0 20.386-4.126.488.488 0 0 1 .594-.334l2.993.816a.518.518 0 0 1 .358.643A15.984 15.984 0 0 1 6.123 28.7l-3.269 3.446A.5.5 0 0 1 2 31.793V20z" })
);

